import { NOT_MEASURED_TEXT } from './measured'

// Since wave 7, /api/mev-stats sums totalVolumeUSD over PRICED flows only and
// reports unpricedFlowCount; flowCount still counts every flow. Show both, and
// never a "$0" total when no flow could be priced. An older API without the
// field keeps the previous display.
export interface WhaleVolumeStats {
  totalVolumeUSD: number
  flowCount: number
  unpricedFlowCount?: number
}

export function whaleVolumeValue(
  s: WhaleVolumeStats | null | undefined,
  formatUSD: (n: number) => string,
): string {
  if (!s) return '—'
  const unpriced = s.unpricedFlowCount
  if (typeof unpriced === 'number' && s.flowCount > 0 && unpriced >= s.flowCount) return NOT_MEASURED_TEXT
  return formatUSD(s.totalVolumeUSD)
}

export function whaleVolumeSub(s: WhaleVolumeStats | null | undefined): string {
  if (!s) return '— institutional flows'
  const unpriced = s.unpricedFlowCount
  if (typeof unpriced !== 'number') return `${s.flowCount} institutional flows`
  return `${Math.max(s.flowCount - unpriced, 0)} priced of ${s.flowCount} institutional flows`
}
